// extracted by mini-css-extract-plugin
module.exports = {"wcstFloater":"who-can-see-this_wcstFloater__3P8qS","label":"who-can-see-this_label__3WbR0"};